/**
 * @file 每个菜单项，用于递归显示子菜单
 * @author  fangsimin
 * @date    2019-01-03 12:14:37
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:40:04
 */

<template>
    <div v-if="data && data['key']" class="menu-items">
        <el-submenu v-if="data['children']"
            :key="data['key']"
            popper-class="submenu-popper"
            :index="getParentKey(routekey)">
            <template slot="title">
                <i v-if="data['icon']"
                    v-bind:class="[getIconClass(data['icon'])]"></i>
                <span slot="title">{{$i18n.t(data['title'])}}</span>
            </template>
            <template v-for="child in data['children']">
                <menu-item v-if="child && child['key']"
                    :key="child['key']"
                    :routekey="getKey(routekey, child['key'])"
                    :data="child"
                ></menu-item>
            </template>
        </el-submenu>
        <el-menu-item v-else
            :key="data['key']"
            :index="getKey(routekey)">
            <i v-if="data['icon']"
                v-bind:class="[getIconClass(data['icon'])]"></i>
            <span slot="title">{{$i18n.t(data['title'])}}</span>
        </el-menu-item>
    </div>
</template>

<script>

/**
 * 获取key，多级key之间用 - 分割
 * @param  {...string} args key数组
 * @return {string}
 */
const specialArr = ['effectMgr', 'batchMgr', 'creativeMgr', 'businessMgr'];
export function getMenuKey(...args) {
    // console.log(args.join('/'), 'ssssss', args);
    let name = args[0] ? args[0].split('/')[2] : '';
    if (specialArr.indexOf(name) > -1) {
        args[0] = name !== '' ? args[0].replace(`/${name}`, '') : args[0];
    }
    // console.log(args.join('/'), 'dddddd', args);
    return args.join('/');
}
const getParentKey = (...args) => {
    return args.join('/');
};

export default {
    name: 'menuItem',
    props: {
        routekey: '',
        data: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {

        };
    },
    methods: {

        /**
         * 获取key，多级key之间用 - 分割
         * @param  {...string} args key数组
         * @return {string}
         */
        getKey: getMenuKey,
        getParentKey: getParentKey,
        /**
         * 获取icon的类名
         * @param  {string} icon icon名
         * @return {string}
         */
        getIconClass: function (icon) {
            return `menu-icon fa fa-${icon}`;
        }
    }
};
</script>
<style lang="scss">
$bg-color: #293965;
$bg-active-color: #1C2950;
$font-active-color: #4583FF;
.el-menu-item {
    position: relative;
}
.submenu-popper {
    background: transparent;
    width: 180px;
    .el-menu--popup {
        padding: 0;
    }
    .el-menu--popup .menu-items .el-menu-item{
        width: 100%;
        box-sizing: border-box;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: $bg-color;
        &:hover, &.is-active {
            background-color: $bg-active-color;
        }
        // &.is-active span {
        //     color: $font-active-color;
        // }
        span {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.5);
        }
    }
}
.el-menu-item > .menu-icon, .el-submenu > .el-submenu__title > .menu-icon {
    /* margin-right: 5px; */
    /* position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 37px; */
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/MenuItem.vue